import Button from "components/atoms/Button/Button";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./style.module.scss";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  getSingleDataWithEmail,
  resetSearchData,
} from "store/slices/data.slice";
import Loading from "components/atoms/Loading/Loading";
import { toast } from "react-toastify";
import InputField from "components/atoms/InputField/InputField";

const LeadFormEmail: React.FC = () => {
  const [emailValue, setEmailValue] = useState("");
  const {
    reset,
    formState: { errors },
  } = useForm<{ email: string }>();
  const { isLoading } = useAppSelector((state) => state.data.searchData);
  const dispatch = useAppDispatch();

  const save = async (data: { email: string }) => {
    await dispatch(getSingleDataWithEmail(data));
    reset();
    setEmailValue("");
  };

  const handleSave = (e: any) => {
    e.preventDefault();
    const valid =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!emailValue) {
      return toast.error("Please fill in an email", {toastId: 'searchSingleEmail'});
    } else if (!valid.test(emailValue.trim())) {
      return toast.error("Please fill a valid email");
    }
    save({ email: emailValue });
  };
  useEffect(() => { dispatch(resetSearchData()) }, []);
  return <form className={styles.form_oneinput}>
    <InputField
      iconName="email"
      className="sm:w-2/4"
      type="text"
      size="small"
      disabled={isLoading}
      value={emailValue}
      onChange={(e: any) => setEmailValue(e.target.value)}
      placeholder="Enter an email address"
    />
    {isLoading 
      ? <div className="flex items-center gap-3">
        <Loading height="38px" spinnerSize={25} />
        <p>Searching...</p>
      </div>
      : <Button
        className="w-full sm:w-max"
        iconName="search" size="sm"
        onClick={(e: any) => handleSave(e)}
      >Single Search</Button>
    }
  </form>
};

export default LeadFormEmail;